module.exports = __webpack_public_path__ + "img/users.fa8a5cf0.svg";